var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-warning",on:{"click":_vm.disable2Fa}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" "+_vm._s(_vm.$t('account.security.2fa.disable.title'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }